export default __webpack_public_path__ + "mark_3.mp4";